// extracted by mini-css-extract-plugin
export default {"LabelBox":"LabelBox_LabelBox__bjMVC","pointerEventNone":"LabelBox_pointerEventNone__uZ-8F"};